import { ACCEPT_TERMS_URL, GET_CONSENT_STATUS_URL, GET_FORM_PROGRESS, get_token, get_headers } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';

export default {
    name: 'ConsentForm',
    mixins: [alert_mixin],
    data: () => ({
            title: 'Platform Consent',
            submitButtonText: 'Accept & Continue',
            verification_running: false,
            acknowledged: false,
            user_id: null,
            token: null,
            application_form_id: null,
            profile_role_form_id: null,
            ready: false
        }),
    mounted() {
        this.user_id = sessionStorage.getItem('user_id');
        this.token = get_token();
        this.profile_role_form_id = sessionStorage.getItem('profile_role_form_id');
        this.application_form_id = sessionStorage.getItem('application_form_id');

        if (!this.user_id || !this.token) {
            return this.redirect_to_login('Session expired. Please log in again.');
        }

        if (!this.is_entity_user()) {
            return this.handle_post_accept_redirection();
        }

        this.bootstrap_consent_status();
    },
    methods: {
        is_entity_user() {
            return sessionStorage.getItem('user_role') === 'Entity';
        },

        async bootstrap_consent_status() {
            // If already cached, skip UI entirely
            if (sessionStorage.getItem('terms_accepted') === 'true') {
                return this.handle_post_accept_redirection();
            }

            // Otherwise confirm with backend; fall back to showing form if unreachable
            try {
                const response = await axios.get(GET_CONSENT_STATUS_URL, {
                    headers: get_headers(),
                });

                if (response?.data?.accepted === true) {
                    sessionStorage.setItem('terms_accepted', 'true');
                    localStorage.setItem('terms_accepted', 'true');
                    return this.handle_post_accept_redirection();
                }
            } catch (error) {
                // fallback to localStorage if backend fails
                if (localStorage.getItem('terms_accepted') === 'true') {
                    sessionStorage.setItem('terms_accepted', 'true');
                    return this.handle_post_accept_redirection();
                }
            }

            this.ready = true;
        },

        async check_form_progress() {
            const  default_Progress = { form_completed: false, current_section_index: 0 };

            if (!this.user_id) {
                this.show_error('User identification is missing. Please log in again.');
                return default_Progress;
            }

            try {
                const params = this.application_form_id
                    ? { application_form_id: this.application_form_id }
                    : { user_id: this.user_id };

                const response = await axios.get(GET_FORM_PROGRESS, {
                    headers: get_headers(),
                    params
                });

                if (response.data.status === 'success') {
                    let form_completes = {
                        form_completed: response.data.is_completed || false,
                        current_section_index: response.data.current_section_index || 0
                    };

                    if (response.data.application_form_id) {
                        this.application_form_id = response.data.application_form_id;
                        sessionStorage.setItem('application_form_id', this.application_form_id);
                        form_completes.application_form_id = this.application_form_id;
                    }

                    return form_completes;
                }

                return default_Progress;

            } catch (error) {
                return default_Progress;
            }
        },

        async accept_terms() {
            if (!this.acknowledged || this.verification_running) return;
            this.verification_running = true;
            try {
                await axios.post(ACCEPT_TERMS_URL, { accepted: true }, {
                    headers: get_headers()
                });
                sessionStorage.setItem('terms_accepted', 'true');
                localStorage.setItem('terms_accepted', 'true');
                await this.handle_post_accept_redirection();
            } catch (error) {
                sessionStorage.removeItem('terms_accepted');
                localStorage.removeItem('terms_accepted');
                const message = error?.response?.data?.error || 'Could not proceed. Please try again.';
                this.show_error(message);
            } finally {
                this.verification_running = false;
            }
        },

        decline_terms() {
            sessionStorage.removeItem('terms_accepted');
            localStorage.removeItem('terms_accepted');
            this.show_info('You have to agree to proceed.');
        },

        async handle_post_accept_redirection() {
            const userRole = sessionStorage.getItem('user_role');
            const progress = await this.check_form_progress();

            if (userRole === 'Entity') {
                if (progress.form_completed) {
                    return this.$router.push('/entity_overview');
                }
                return this.$router.push({ path: '/attribute_forms' });
            } else if (userRole === 'Lead') {
                return this.$router.push('/entity_enquiry_management');
            }
            return this.$router.push('/company_management');
        },

        redirect_to_login(reason) {
            if (reason) sessionStorage.setItem('auth_redirect_reason', reason);
            sessionStorage.removeItem('terms_accepted');
            sessionStorage.removeItem('otp_verified');
            sessionStorage.removeItem('token');
            localStorage.removeItem('encrypted_token');
            localStorage.removeItem('token');
            this.$router.replace({ name: 'UserLogin' });
        }
    }
};

